import './style.css'
import Experience from './Experience/Experience.js'
import MainMenu from './Experience/Menu/MainMenu.js'
import SelectScreen from './Experience/Menu/SelectScreen.js'
import mapCatalog from './Experience/Content/MapCatalog.js'

/**
 * Fluxo:
 * 1. MainMenu (música / Jogar / Solo)
 * 2. SelectScreen — garagem FODA (carro, piloto, pista, cor, nome, sala)
 * 3. Experience (jogo 3D)
 */
let experience = null

function ensureGame() {
    if (!experience) {
        experience = new Experience(document.querySelector('canvas.webgl'))
        window.__kartExperience = experience
    }
    return experience
}

function showMpBar(net) {
    let bar = document.getElementById('kart-mp-bar')
    if (!bar) {
        bar = document.createElement('div')
        bar.id = 'kart-mp-bar'
        bar.style.cssText = 'position:fixed;left:50%;top:10px;transform:translateX(-50%);z-index:60;background:rgba(0,0,0,0.55);color:#fff;padding:8px 16px;border-radius:20px;font:600 13px system-ui;pointer-events:none;max-width:92vw;text-align:center;border:1px solid rgba(0,212,255,0.25)'
        document.body.appendChild(bar)
    }
    net.onStatus = (m) => { bar.textContent = m }
    return bar
}

function applySelection(exp, sel) {
    const net = exp.kartNet
    net.myName = sel.name
    net.myColor = sel.color
    net.myCar = sel.car
    if (net.setMyCar) net.setMyCar(sel.car)
    if (net.setMyCharacter) net.setMyCharacter(sel.character)
    else {
        net.myCharacter = sel.character
        exp.simpleCar?.setCharacter?.(sel.character)
    }
    exp.simpleCar?.setCar?.(sel.car, sel.color)
    exp.simpleCar?.updateColor?.(sel.color)

    // mapa ativo
    try {
        const active = mapCatalog.setActive(sel.map)
        if (exp.world?.floor?.applyMap) exp.world.floor.applyMap(active)
    } catch (e) {
        console.warn('[map]', e)
    }
}

function openSelect(mode) {
    // esconde prompt legado se ainda estiver no DOM
    const legacy = document.getElementById('kart-name-prompt')
    if (legacy) {
        legacy.classList.add('hidden')
        legacy.classList.remove('visible')
    }

    const select = new SelectScreen({
        mode,
        onBack: () => {
            // volta ao menu principal
            bootMenu()
        },
        onConfirm: (sel) => {
            const exp = ensureGame()
            applySelection(exp, sel)
            const net = exp.kartNet
            showMpBar(net)

            if (sel.mode === 'solo') {
                net.status('Corrida solo — boa sorte!')
                return
            }
            if (sel.mode === 'join') {
                net.joinRoom(sel.roomCode, sel.name, sel.color)
            } else {
                net.hostRoom(sel.name, sel.color)
            }
        },
    })
    window.__kartSelect = select
}

function bootMenu() {
    const menu = new MainMenu({
        onPlay: () => openSelect('host'),
        onSolo: () => openSelect('solo'),
    })
    window.__kartMenu = menu
}

// esconde prompt HTML legado (substituído pela SelectScreen)
const legacyPrompt = document.getElementById('kart-name-prompt')
if (legacyPrompt) {
    legacyPrompt.classList.add('hidden')
    legacyPrompt.classList.remove('visible')
}

bootMenu()
